import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import {authentication} from '@/settings';
import {AuthLayout} from '@dofleini/auth-layout';
import {useQuery} from 'react-query';
import SpaceApiService from '@/modules/admin/services/SpaceApiService';
import {ApiClientService} from '@dofleini/security';
import {useTheme} from '@/contexts/ThemeContext';
import BgLogin from '../assets/images/login-bg.png';

const AuthenticationAppLayout = ({children}) => {
  const {setTheme} = useTheme();
  const {data} = useQuery(['space-setting', ApiClientService.getSpace()], async () => {
    const {data} = await SpaceApiService.getCurrent();
    return data;
  });

  const settings = useMemo(() => {
    const setting = Object.assign(authentication, data?.metadata?.auth || {});
    setting.background = data?.metadata?.auth.color || authentication.background || BgLogin;
    setting.image = BgLogin;
    setTheme(data?.metadata);
    return setting;
  }, [data, setTheme]);

  return (
    <AuthLayout {...settings} rightClass={'place-item-center'}>
      <div>
        {children}
      </div>
    </AuthLayout>
  );
};
AuthenticationAppLayout.propTypes = {
  children: PropTypes.any,
};

export default memo(AuthenticationAppLayout);
